import _ from 'lodash'

export function getProduct (products, product) {
  var myProduct = _.filter(products, function (item) {
    return item.label === product
  })
  return myProduct
}

export function changeMetrics (sensorIds, metrics, trackables) {
  return sensorIds.map(function (sensorId) {
    const result = metrics.find((metric) => {
      return sensorId === metric.sensor
    })
    if (result) {
      return result
    } else {
      var label = sensorId.substring(6, sensorId.length)
      var trackable = trackables.find((trb) => {
        return label === trb.id
      })
      return {
        sensor: sensorId,
        value: 0,
        occurred_at: new Date().toJSON(),
        received_at: new Date().toJSON(),
        metadata: {
          trb_imm: trackable.label
        }
      }
    }
  })
}
